<script lang="ts">
	import { _ } from 'svelte-i18n';
	import IconButton from '../../buttons/IconButton.svelte';

	let spamProtected = $state(false);
	interface Props {
		showAdd?: boolean;
		spamProtectedCall?: ((index: number) => Promise<any>) | null;
		onAddRequest?: (index: number) => void;
	}

	let { showAdd = false, spamProtectedCall = null, onAddRequest }: Props = $props();
</script>

<div style="height: 100px;" class="grid items-center justify-center">
	{#if showAdd}
		<div>
			<IconButton
				primary={true}
				iconName="plus"
				size="small"
				hoverText={$_('basic_components.bt_add')}
				onClick={() => {
					if (spamProtectedCall) {
						//Prevent the call
						if (spamProtected) return;

						//Set as running
						spamProtected = true;

						//Call the callable
						spamProtectedCall(-1)
							//Add small delay for reactivation
							.then(() => new Promise((resolve) => setTimeout(resolve, 200)))
							.finally(() => {
								//Revert the runnung flag
								spamProtected = false;
							});
					} else {
						//Send the event
						onAddRequest?.(-1);
					}
				}}
			/>
		</div>
	{/if}
</div>
